import { ComponentPropsWithRef } from 'react'
import { cn } from '@/lib/utils'

type ContainerProps = ComponentPropsWithRef<'div'>

export const Container = ({ children, className, ...props }: ContainerProps) => (
  <div {...props} className={cn(`relative min-h-[382px] w-full rounded-xl bg-white px-6 py-7 shadow-loose-plus`, className)}>
    {children}
  </div>
)

type ScrollableRouteContainerProps = ComponentPropsWithRef<'div'>

export const ScrollableRouteContainer: React.FC<ScrollableRouteContainerProps> = ({ children, className, ref, ...props }) => (
  <div {...props} ref={ref} className={cn(`h-screen w-full bg-gray-10 px-8 pb-32 pt-6`, className)}>
    {children}
  </div>
)

export const LayoutContainer = ({ children, className, ...props }: ContainerProps) => (
  <div {...props} className={cn(`relative h-screen w-full overflow-y-auto bg-gray-50`, className)}>
    {children}
  </div>
)
